import React, { useContext, useEffect } from 'react'
import Transactions from '../Components/Transactions'
import { Context } from '../Context/Context'

const Transaction = ({ verified }) => {

    const {
        viewTransactionDetails,
        sideBar
    } = useContext(Context)

    useEffect(() => {
        if (viewTransactionDetails || sideBar) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [viewTransactionDetails, sideBar])

    return <Transactions verified={verified} />
}

export default Transaction